module.exports = __webpack_public_path__ + "img/brighten_seed_logo_new.40eb073a.png";